import Pen from '../assets/icons/pen.svg'
import Name from '../assets/icons/letter.svg'
import DOB from '../assets/icons/exam.svg'
import Gender from '../assets/icons/gender.svg'
import Note from '../assets/icons/note.svg'


export const cod = [
    {
      id: 1,
      name: 'Change of Course/Institution',
      icon: Pen,
      alt: 'change_icon',
      instruction: 'CHANGE OF COURSE/INSTITUTION',
      content: <p>
      You shall be required to create a profile via the Sign Up (New User) Page if you are a new user. For existing users, simply type in your login 
      details. To create your profile, you will provide your valid email address, surname, first name, Mobile No, State and LGA of Origin and password, 
      then click on the Sign Up button. Each candidate is entitled to only one profile.
      <br />
      <br />
      Subsequently, you shall use your email address and password to sign in.
      <br />
      <br />
      Once logged in, you will be taken to the landing page where you will see all available services.
      <br />
      <br />
      Select “Correction of Data”. This is available on the side bar or on the Home page
      <br />
      <br />
      Once selected, the menu item “Course/Institution” will be revealed. Click this.
      <br />
      <br />
      Once you select this service, a Transaction ID is generated for this service. This will be displayed on the confirmation page screen.
      <br />
      <br />
      Review the details displayed on the Confirmation Page. Also, note the Transaction ID displayed in a bold red font. The Transaction ID is useful 
      for all future references concerning the Transaction. A copy of this transaction ID will be sent to your registered email address.
      <br />
      <br />
      Click on the Continue button if you wish to pay with your card immediately. If you wish to use other payment channels like ATM, Cash 
      at the Bank or Quickteller, please note the transaction ID as it will be required.
      <br />
      <br />
      On the Interswitch Payment page, enter your card details and click on the Pay button.
      <br />
      <br />
      The status of your payment will be displayed on the “My Payment Section” An SMS and email containing your unique Transaction Identification 
      and payment status will be sent to you after payment. Click on the Continue button.
      <br />
      <br />
      Once payment is completed, you will be asked to provide the following: a. Year of Exam and b. JAMB Registration Number
      <br />
      <br />
      After entering the information correctly, new options for Preferred course/Institution and second choices will appear. Options available will 
      be based on availability.
      <br />
      <br />
      Click Submit to complete your application.
      <br />
      <br />
      JAMB will now process your application. If Approved, your details will be changed as requested.
      </p>
    },
    {
      id: 2,
      name: 'Change of Name',
      icon: Name,
      alt: 'change_icon',
      instruction: 'CORRECTION OF NAMES',
      content: <p>
      You shall be required to create a profile via the Sign Up (New User) Page if you are a new user. For existing users, simply type in your login 
      details. To create your profile, you will provide your valid email address, surname, first name, Mobile No, State and LGA of Origin and 
      password, then click on the Sign Up button. Each candidate is entitled to only one profile.
      <br />
      <br />
      Subsequently, you shall use your email address and password to sign in.
      <br />
      <br />
      Once logged in, you will be taken to the landing page where you will see all available services.
      <br />
      <br />
      Select “Correction of Data”. This is available on the side bar
      <br />
      <br />
      Once selected, the menu item “Names” will be revealed. Click this.
      <br />
      <br />
      Once you select this service, a Transaction ID is generated for this service. This will be displayed on the confirmation page screen.
      <br />
      <br />
      Review the details displayed on the Confirmation Page. Also, note the Transaction ID displayed in a bold red font. The Transaction ID is 
      useful for all future references concerning the Transaction. A copy of this transaction ID will be sent to your registered email address.
      <br />
      <br />
      Click on the Continue button if you wish to pay with your card immediately. If you wish to use other payment channels like ATM, Cash at the 
      Bank or Quickteller, please note the transaction ID as it will be required.
      <br />
      <br />
      On the Interswitch Payment page, enter your card details and click on the Pay button.
      <br />
      <br />
      The status of your payment will be displayed on the “My Payment Section” An SMS and email containing your unique Transaction Identification 
      and payment status will be sent to you after payment. Click on the Continue button.
      <br />
      <br />
      Once payment is completed, you will be asked to provide the following: a. Year of Exam and b. JAMB Registration Number
      <br />
      <br />
      After entering the information correctly, your details will now appear.
      <br />
      <br />
      Please provide the new information in the boxes provided.
      <br />
      <br />
      After submission, an Indemnity Form will be displayed for printing.
      <br />
      <br />
      This is to be filled and taken to your institution for Approval.
      <br />
      <br />
      Your institution will be responsible for submission of the approved form to the JAMB state office.
      <br />
      <br />
      Once received, the Approved form will be uploaded to your profile. You will receive a notification when this is done.
      <br />
      <br />
      JAMB will now process your application. If Approved, your details will be changed as requested.
      </p>,
    },
    {
      id: 3,
      name: 'Change of DOB',
      icon: DOB,
      alt: 'change_icon',
      instruction: 'CORRECTION OF DATE OF BIRTH',
      content: <p>
      You shall be required to create a profile via the Sign Up (New User) Page if you are a new user. For existing users, simply type in your 
      login details. To create your profile, you will provide your valid email address, surname, first name, Mobile No, State and LGA of Origin 
      and password, then click on the Sign Up button. Each candidate is entitled to only one profile.
      <br />
      <br />
      Subsequently, you shall use your email address and password to sign in.
      <br />
      <br />
      Once logged in, you will be taken to the landing page where you will see all available services.
      <br />
      <br />
      Select “Correction of Data”. This is available on the side bar
      <br />
      <br />
      Once selected, the menu item “Date of Birth” will be revealed. Click this.
      <br />
      <br />
      Once you select this service, a Transaction ID is generated for this service. This will be displayed on the confirmation page screen.
      <br />
      <br />
      Review the details displayed on the Confirmation Page. Also, note the Transaction ID displayed in a bold red font. The Transaction ID 
      is useful for all future references concerning the Transaction. A copy of this transaction ID will be sent to your registered email address.
      <br />
      <br />
      Click on the Continue button if you wish to pay with your card immediately. If you wish to use other payment channels like ATM, Cash at the 
      Bank or Quickteller, please note the transaction ID as it will be required.
      <br />
      <br />
      On the Interswitch Payment page, enter your card details and click on the Pay button.
      <br />
      <br />
      The status of your payment will be displayed on the “My Payment Section” An SMS and email containing your unique Transaction Identification 
      and payment status will be sent to you after payment. Click on the Continue button.
      <br />
      <br />
      Once payment is completed, you will be asked to provide the following: a. Year of Exam and b. JAMB Registration Number
      <br />
      <br />
      After entering the information correctly, your incorrect date of birth will now appear.
      <br />
      <br />
      Please provide the new information in the boxes provided.
      <br />
      <br />
      After submission, an Indemnity Form will be displayed for printing.
      <br />
      <br />
      This is to be filled and taken to your institution for Approval.
      <br />
      <br />
      Your institution will be responsible for submission of the approved form to the JAMB state office.
      <br />
      <br />
      Once received, the Approved form will be uploaded to your profile. You will receive a notification when this is done.
      <br />
      <br />
      JAMB will now process your application. If Approved, your details will be changed as requested.
      </p>,
    },
    {
      id: 4,
      name: 'Change of Gender',
      icon: Gender,
      alt: 'change_icon',
      instruction: 'CORRECTION OF GENDER',
      content: <p>
      You shall be required to create a profile via the Sign Up (New User) Page if you are a new user. For existing users, simply type in your 
      login details. To create your profile, you will provide your valid email address, surname, first name, Mobile No, State and LGA of Origin ]
      and password, then click on the Sign Up button. Each candidate is entitled to only one profile.
      <br />
      <br />
      Subsequently, you shall use your email address and password to sign in.
      <br />
      <br />
      Once logged in, you will be taken to the landing page where you will see all available services.
      <br />
      <br />
      Select “Correction of Data”. This is available on the side bar
      <br />
      <br />
      Once selected, the menu item “Gender” will be revealed. Click this.
      <br />
      <br />
      Once you select this service, a Transaction ID is generated for this service. This will be displayed on the confirmation page screen.
      <br />
      <br />
      Review the details displayed on the Confirmation Page. Also, note the Transaction ID displayed in a bold red font. The Transaction ID is 
      useful for all future references concerning the Transaction. A copy of this transaction ID will be sent to your registered email address.
      <br />
      <br />
      Click on the Continue button if you wish to pay with your card immediately. If you wish to use other payment channels like ATM, Cash at the 
      Bank or Quickteller, please note the transaction ID as it will be required.
      <br />
      <br />
      On the Interswitch Payment page, enter your card details and click on the Pay button.
      <br />
      <br />
      The status of your payment will be displayed on the “My Payment Section” An SMS and email containing your unique Transaction Identification 
      and payment status will be sent to you after payment. Click on the Continue button.
      <br />
      <br />
      Once payment is completed, you will be asked to provide the following: a. Year of Exam and b. JAMB Registration Number
      <br />
      <br />
      After entering the information correctly, your incorrect gender will now appear.
      <br />
      <br />
      Please provide the new information in the boxes provided.
      <br />
      <br />
      After submission, an Indemnity Form will be displayed for printing.
      <br />
      <br />
      This is to be filled and taken to your institution for Approval.
      <br />
      <br />
      Your institution will be responsible for submission of the approved form to the JAMB state office.
      <br />
      <br />
      Once received, the Approved form will be uploaded into your profile. You will receive a notification when this is done.
      <br />
      <br />
      JAMB will now process your application. If Approved, your details will be changed as requested.
      </p>,
    },
    {
      id: 5,
      name: 'Change of LGA/State',
      icon: Note,
      alt: 'change_icon',
      instruction: 'Correction Of State/LGA Of Origin',
      content: <p>
      You shall be required to create a profile via the Sign Up (New User) Page if you are a new user. For existing users, simply type in your 
      login details. To create your profile, you will provide your valid email address, surname, first name, Mobile No, State and LGA of Origin 
      and password, then click on the Sign Up button. Each candidate is entitled to only one profile.
      <br />
      <br />
      Subsequently, you shall use your email address and Password to Sign In
      <br />
      <br />
      Once logged in, you will be taken to the landing page where you will see all available services.
      <br />
      <br />
      Select “Correction of Data”. This is available on the side bar
      <br />
      <br />
      Once selected, the menu item “State/LGA of Origin” will be revealed. Click this.
      <br />
      <br />
      Once you select this service, a Transaction ID is generated for this service. This will be displayed on the confirmation page screen.
      <br />
      <br />
      Review the details displayed on the Confirmation Page. Also, note the Transaction ID displayed in bold in red. The Transaction ID is useful 
      for all future references concerning the Transaction. A copy of this transaction ID will be sent to your registered email address.
      <br />
      <br />
      Click on the Continue button if you wish to pay with your card immediately. If you wish to use other payment channels like ATM, Cash at the 
      Bank and Quickteller, please note the transaction ID as it will be required.
      <br />
      <br />
      On the Interswitch Payment page, enter your card details and click on the Pay button.
      <br />
      <br />
      The status of your payment will be displayed on the “My Payment Section” An SMS and email containing your unique Transaction Identification 
      and payment status will be sent to you after payment. Click on the Continue button.
      <br />
      <br />
      Once payment is completed, you will be asked to provide the following: a. Year of Exam and b. JAMB Registration Number
      <br />
      <br />
      After entering the information correctly, state and local government will now appear.
      <br />
      <br />
      Please provide the new information in the boxes provided.
      <br />
      <br />
      After submission, an Indemnity form will be displayed for printing.
      <br />
      <br />
      This is to be filled and taken to your institution for Approval.
      <br />
      <br />
      Your institution will be responsible for submission of the approved form to the JAMB state office.
      <br />
      <br />
      Once received, the Approved form will be uploaded into your profile. You will receive a notification when this is done.
      <br />
      <br />
      JAMB will now process your application. If Approved, your details will be changed as requested.
      </p>,
    },
  ]